import { FunctionComponent } from 'react'
import { Flex, Text } from '@conexasaude/conexa-hero'
import { DescriptionProps } from './types'
import { HIGHLIGHTED_TEXT, SECONDARY_TEST } from './constants'

const Description: FunctionComponent<DescriptionProps> = ({
  guardianFormStatus,
}) => {
  return (
    <Flex mt="xs" direction="column">
      <Text fontWeight={600} variant="paragraphLarge">
        {HIGHLIGHTED_TEXT[guardianFormStatus]}
      </Text>
      <Text variant="paragraphLarge">{SECONDARY_TEST[guardianFormStatus]}</Text>
    </Flex>
  )
}

export { Description }
